function fetchEventDetailsQuery (id) {
  let variables = { id }

  return {
    operationName: 'fetchEventDetailsQuery',
    query: `
      query fetchEventDetailsQuery($id: Int!) {
        veranstaltung:event(id: $id) {
          _entityName
          _stringRep
          name
          veranstaltungsTyp:type
          veranstaltungStart:startDate
          veranstaltungEnde:endDate
          beschreibungDE:descriptionDe
          beschreibungEN:descriptionEn
          externeWebsite:externalEventWebsite
          organisationseinheit:organisationalUnit {
            _id:id
            _entityName
            _stringRep
            parentOrgaName
          }
          relevantFuerWeitere:hasMultipleOus
          weitereOrganisationseinheiten:additionalOrganisationalUnits {
            _id:id
            _entityName
            _stringRep
            parentOrgaName
          }
          veranstalter:organisers {
            _stringRep: fullName
            _entityName
            fisPersid
            orcid
          }
          stadt:city
          land:country {
            _stringRep
            _entityName
          }
          virtuell:virtual
        }
      }
    `,
    variables
  }
}

export { fetchEventDetailsQuery }



// WEBPACK FOOTER //
// ./src/graphql/eventDetails.js